import AppControlGuids from '../api/ControlGuids';
import LibControlGuids from 'frontier/nucleus/src/lib/apiv2/ControlGuids';
import ControlGuids from '../api/ControlGuids';

export enum ProtectedView {
  ProcessOverviewComponent = 'ProcessOverviewComponent',
  MissionDataCollectionComponent = 'MissionDataCollectionComponent',
  PayerOverviewComponent = 'PayerOverviewComponent',
  TariffChangesComponent = 'TariffChangesComponent',
  RescueStationComponent = 'RescueStationComponent',
  TemplatesControl = 'TemplatesControl',
  DunningConfigComponent = 'DunningConfigComponent',
  DtaServiceConflictTableComponent = 'DtaServiceConflictTableComponent',
  ConfigurationOverviewComponent = 'ConfigurationOverviewComponent',
  OnboardingOverviewComponent = 'OnboardingOverviewComponent',
  ItemTableComponent = 'ItemTableComponent',
  ItemGroupTypeTableComponent = 'ItemGroupTypeTableComponent',
  ItemGroupBaseTableComponent = 'ItemGroupBaseTableComponent',
  PayerTableComponent = 'PayerTableComponent',
  DataOfficeBaseTableComponent = 'DataOfficeBaseTableComponent',
  InvoiceTemplateTableComponent = 'InvoiceTemplateTableComponent',
  CollectiveinvoiceTableComponent = 'CollectiveinvoiceTableComponent',
  CarttypeTableComponent = 'CarttypeTableComponent',
  AddressinfoTableComponent = 'AddressinfoTableComponent',
  BusinessAreasTableComponent = 'BusinessAreasTableComponent',
  ItemPriceMappingTableComponent = 'ItemPriceMappingTableComponent',
  InvoiceTemplateConfigFormComponent = 'InvoiceTemplateConfigFormComponent',
  GlobalTemplateConfigFormComponent = 'GlobalTemplateConfigFormComponent',
  BaseInvoiceTemplateConfigTableComponent = 'BaseInvoiceTemplateConfigTableComponent',
  ConspicuityDetailComponent = 'ConspicuityDetailComponent',
  ClientDetailComponent = 'ClientDetailComponent',
  TransportDetailComponent = 'TransportDetailComponent',
  CrewDetailComponent = 'CrewDetailComponent',
  CartAdditionalDetailComponent = 'CartAdditionalDetailComponent',
  InvoiceDetailComponent = 'InvoiceDetailComponent',
  DocumentDetailComponent = 'DocumentDetailComponent',
  ShippingAndPaymentComponent = 'ShippingAndPaymentComponent',
  InternalNoteDetailComponent = 'InternalNoteDetailComponent',
  PermanentOrdinanceComponent = 'PermanentOrdinanceComponent',
  PayerHiddenTableComponent = 'PayerHiddenTableComponent',
  DataofficeTableComponent = 'DataofficeTableComponent',
  AlternativePayerTableComponent = 'AlternativePayerTableComponent',
  CustomerBasedataConfigFormComponent = 'CustomerBasedataConfigFormComponent',
  BookingOptionsConfigFormComponent = 'BookingOptionsConfigFormComponent',
  OpenItemImportConfigFormComponent = 'OpenItemImportConfigFormComponent',
  EpostConfigWrapperComponent = 'EpostConfigWrapperComponent',
  VerificationRulesConfigFormComponent = 'VerificationRulesConfigFormComponent',
  UserListComponent = 'UserListComponent',
  BillingEvaluations = 'BillingEvaluationsComponent',
  MailTemplateComponent = 'MailTemplateComponent',
  SmtpConfigurationComponent = 'SmtpConfigurationComponent',
  ChangeLogComponent = 'ChangeLogComponent',
  LanguageImportTableComponent = 'LanguageImportTableComponent',
  DictionaryImportTableComponent = 'DictionaryImportTableComponent',
  ConfigLanguageImportTableComponent = 'ConfigLanguageImportTableComponent',
  DunningConfigImportTableComponent = 'DunningConfigImportTableComponent',
  DunningLevelImportTableComponent = 'DunningLevelImportTableComponent',
  InvoiceAutomationEditorComponent = 'InvoiceAutomationEditorComponent',
  InvoiceAutomationImportComponent = 'InvoiceAutomationImportComponent',
  LanguageConfigComponent = 'LanguageConfigComponent',
  VehicleComponent = 'VehicleComponent',
}

/**
 * Map that contains for each key a set of guids that need
 * to be authorized to access the corresponding component.
 * At least one of the guids in the set must be present in the
 * user's roles to access the component.
 */
export const AUTHORIZATION_CONFIG: Record<ProtectedView, string[]> = {
  // --- SIDE NAVIGATION -------
  [ProtectedView.ProcessOverviewComponent]: [
    AppControlGuids.TFullCartStatus,
    AppControlGuids.TAllClientList,
    AppControlGuids.TOutboxBook,
    AppControlGuids.TOpenItemList,
    AppControlGuids.TCartList,
  ],
  [ProtectedView.MissionDataCollectionComponent]: [
    AppControlGuids.TTransportList,
    AppControlGuids.TNotBillable,
    AppControlGuids.TAllClientList,
    AppControlGuids.TCartList,
    AppControlGuids.TCrewList,
    AppControlGuids.TOrdinanceList,
    AppControlGuids.TClientList,
  ],
  [ProtectedView.PayerOverviewComponent]: [
    AppControlGuids.TPayerTableView,
    AppControlGuids.TAlternativePayerView,
    AppControlGuids.TDataOfficeTableView,
  ],
  [ProtectedView.BillingEvaluations]: [
    AppControlGuids.TInvoiceExport,
    AppControlGuids.TTransportExport,
    ControlGuids.TCartExport,
    AppControlGuids.TBookingrecordExport,
  ],
  [ProtectedView.TariffChangesComponent]: [AppControlGuids.TItemPriceHistoryView],
  [ProtectedView.RescueStationComponent]: [AppControlGuids.TStationTableView],
  [ProtectedView.VehicleComponent]: [AppControlGuids.TVehicleTableView],
  [ProtectedView.TemplatesControl]: [AppControlGuids.TTemplateConfigurationControl],
  [ProtectedView.DunningConfigComponent]: [AppControlGuids.TDunningConfigView, AppControlGuids.TDunningLevelView],
  [ProtectedView.LanguageConfigComponent]: [ControlGuids.TLanguageTable, ControlGuids.TDictionaryTable],
  [ProtectedView.DtaServiceConflictTableComponent]: [AppControlGuids.TDTAServiceConfigView],
  [ProtectedView.UserListComponent]: [LibControlGuids.TUserListTable],
  [ProtectedView.ConfigurationOverviewComponent]: [
    AppControlGuids.TEpostConfiguration,
    AppControlGuids.TCustomerBasedataConfiguration,
    AppControlGuids.TBookingOptionsConfig,
    AppControlGuids.TOpenItemImportConfig,
    AppControlGuids.TTestingSettingsConfig,
    AppControlGuids.TSepaConfigForm,
    LibControlGuids.TEmailTemplateForm,
    LibControlGuids.TEMailSmtpConfiguration,
  ],
  // --- SIDE DEV NAVIGATION ---
  [ProtectedView.OnboardingOverviewComponent]: [
    AppControlGuids.TPayerDataOfficeTable,
    AppControlGuids.TPayerTable,
    AppControlGuids.TItemTable,
    AppControlGuids.TItemgroupTable,
    AppControlGuids.TItemGroupTypeView,
    AppControlGuids.TItemPriceHistoryView,
    AppControlGuids.TBusinessAreaMappingTable,
    AppControlGuids.TItemPriceMapping,
    AppControlGuids.TAlternativePayerView,
    AppControlGuids.TPayerTableView,
    AppControlGuids.TBookingOptionsConfig,
    AppControlGuids.TCustomerBasedataConfiguration,
    AppControlGuids.TDTAServiceConfigView,
    AppControlGuids.TGlobalTemplateConfigForm,
    AppControlGuids.TInvoiceTemplateImportTable,
    AppControlGuids.TTemplateConfigurationControl,
    AppControlGuids.TLanguageImportView,
    AppControlGuids.TDictionaryImportView,
    AppControlGuids.TConfigLanguageImportView,
    AppControlGuids.TDunningConfigImportView,
    AppControlGuids.TDunningConfigView,
    AppControlGuids.TDunningLevelImportView,
    AppControlGuids.TInvoiceAutomationView,
    AppControlGuids.TInvoiceAutomationImportView,
    AppControlGuids.TOpenItemImportConfig,
    AppControlGuids.TEpostConfiguration,
    AppControlGuids.TStationTableView,
  ],
  [ProtectedView.ItemTableComponent]: [AppControlGuids.TItemTable],
  [ProtectedView.ItemGroupBaseTableComponent]: [AppControlGuids.TItemgroupTable],
  [ProtectedView.ItemGroupTypeTableComponent]: [AppControlGuids.TItemGroupTypeView],
  [ProtectedView.PayerTableComponent]: [AppControlGuids.TPayerTable],
  [ProtectedView.DataOfficeBaseTableComponent]: [AppControlGuids.TPayerDataOfficeTable],
  [ProtectedView.InvoiceTemplateTableComponent]: [AppControlGuids.TInvoiceTemplateTable],
  [ProtectedView.CollectiveinvoiceTableComponent]: [AppControlGuids.TCollectiveInvoiceTable],
  [ProtectedView.CarttypeTableComponent]: [AppControlGuids.TCartTypeTable],
  [ProtectedView.AddressinfoTableComponent]: [AppControlGuids.TAddressInfoView],
  [ProtectedView.BusinessAreasTableComponent]: [AppControlGuids.TBusinessAreaMappingTable],
  [ProtectedView.ItemPriceMappingTableComponent]: [AppControlGuids.TItemPriceMapping],
  [ProtectedView.InvoiceTemplateConfigFormComponent]: [AppControlGuids.TInvoiceTemplateConfigForm],
  [ProtectedView.GlobalTemplateConfigFormComponent]: [AppControlGuids.TGlobalTemplateConfigForm],
  [ProtectedView.BaseInvoiceTemplateConfigTableComponent]: [AppControlGuids.TInvoiceTemplateImportTable],
  // ----------------------------

  // --- CART DETAIL TABS ------
  [ProtectedView.ConspicuityDetailComponent]: [AppControlGuids.TNotBillable],
  [ProtectedView.ClientDetailComponent]: [AppControlGuids.TClientList],
  [ProtectedView.TransportDetailComponent]: [AppControlGuids.TTransportList],
  [ProtectedView.CrewDetailComponent]: [AppControlGuids.TOrdinanceList, AppControlGuids.TCrewList],
  [ProtectedView.CartAdditionalDetailComponent]: [AppControlGuids.TCrudCartAdditionaldata],
  [ProtectedView.ShippingAndPaymentComponent]: [AppControlGuids.TClientDebit],
  [ProtectedView.InvoiceDetailComponent]: [
    AppControlGuids.TInvoiceList,
    AppControlGuids.TDunningInfo,
    AppControlGuids.TCartItemsList,
  ],
  [ProtectedView.DocumentDetailComponent]: [AppControlGuids.TTrapoList, AppControlGuids.TCartDocumentList],
  [ProtectedView.InternalNoteDetailComponent]: [AppControlGuids.TInternalNotes],
  [ProtectedView.PermanentOrdinanceComponent]: [AppControlGuids.TPermanentOrdinanceForClient],
  [ProtectedView.ChangeLogComponent]: [AppControlGuids.TCrudChangelog],
  // ----------------------------

  // --- PAYER OVERVIEW TABS ----
  [ProtectedView.PayerHiddenTableComponent]: [AppControlGuids.TPayerTableView],
  [ProtectedView.DataofficeTableComponent]: [AppControlGuids.TDataOfficeTableView],
  [ProtectedView.AlternativePayerTableComponent]: [AppControlGuids.TAlternativePayerView],
  // ----------------------------

  // --- GENERAL SETTINGS TABS -- (App Configuration Overview)
  [ProtectedView.CustomerBasedataConfigFormComponent]: [AppControlGuids.TCustomerBasedataConfiguration],
  [ProtectedView.BookingOptionsConfigFormComponent]: [
    AppControlGuids.TBookingOptionsConfig,
    AppControlGuids.TSepaConfigForm,
  ],
  [ProtectedView.OpenItemImportConfigFormComponent]: [AppControlGuids.TOpenItemImportConfig],
  [ProtectedView.EpostConfigWrapperComponent]: [AppControlGuids.TEpostConfiguration],
  [ProtectedView.MailTemplateComponent]: [LibControlGuids.TEmailTemplateForm],
  [ProtectedView.SmtpConfigurationComponent]: [LibControlGuids.TEMailSmtpConfiguration],
  [ProtectedView.VerificationRulesConfigFormComponent]: [AppControlGuids.TTestingSettingsConfig],
  // ----------------------------

  // --- ONBOARDING ONLY TABS ---
  [ProtectedView.LanguageImportTableComponent]: [AppControlGuids.TLanguageImportView],
  [ProtectedView.DictionaryImportTableComponent]: [AppControlGuids.TDictionaryImportView],
  [ProtectedView.ConfigLanguageImportTableComponent]: [AppControlGuids.TConfigLanguageImportView],
  [ProtectedView.DunningConfigImportTableComponent]: [AppControlGuids.TDunningConfigImportView],
  [ProtectedView.DunningLevelImportTableComponent]: [AppControlGuids.TDunningLevelImportView],
  [ProtectedView.InvoiceAutomationEditorComponent]: [AppControlGuids.TInvoiceAutomationView],
  [ProtectedView.InvoiceAutomationImportComponent]: [AppControlGuids.TInvoiceAutomationImportView],
  // ----------------------------

}
